
<np-header [sitename]="'it engineering portal'" [welcomeMessage]="welcome()" [menuItems]="navigationItems" ></np-header>
<np-nav [navItems]="navigationItems"></np-nav>

<router-outlet></router-outlet>
@if (showScroll())
{
    <app-scroll-up (scrollTop)="onScrollTop()"></app-scroll-up>
}
<np-footer  [contentContactName]="'Kurt Charney'" 
            [contentContactUrl]="'mailto:kcharney@chevron.com'"
            [technicalContactName]="'SMAPES - Development Foundations'" 
            [technicalContactUrl]="'mailto:ITF-APES-DevelopmentFoundations-PaaSRoles@chevron.com'"
            [opCoName]="'IT Foundation'"
            [opCoUrl]="'https://chevron.sharepoint.com/sites/ITFP'" >
</np-footer>